export const faqs = [
  {
    id: 1,
    category: 'Spolupráca',
    question: 'Ako dlho trvá spustenie prvej kampane?',
    answer:
      'Zvyčajne 5–10 pracovných dní od podpisu zmluvy. Začíname onboarding call, kde nastavíme prístupy, zanalyzujeme konkurenciu a spustíme prvé kampane. Na výsledky v SEO čakáme 3–6 mesiacov, PPC kampane prinášajú návštevnosť od prvého dňa.',
  },
  {
    id: 2,
    category: 'Ceny',
    question: 'Koľko stojí spolupráca a ako funguje platba?',
    answer:
      'Ceny sa odvíjajú od rozsahu projektu - štartovacie balíčky začínajú od 490 €/mesiac. Fakturujeme vždy na začiatku mesiaca, bez dlhodobých záväzkov. Pri ročnej platbe vopred poskytujeme 15 % zľavu. Pred podpisom dostanete presnú cenovú ponuku bez skrytých poplatkov.',
  },
  {
    id: 3,
    category: 'Výsledky',
    question: 'Viete zaručiť konkrétne výsledky alebo pozície v Googli?',
    answer:
      'Nikto nemôže zaručiť konkrétne pozície, pretože Google algoritmus sa neustále mení. Čo garantujem ja: transparentný reporting každý mesiac, konzistentný rast organickej návštevnosti a merateľné zlepšenie konverzného pomeru. Výsledky závisia od stavu webu, konkurencie a investovaného času - ale vždy vidíte, čo sa deje.',
  },
  {
    id: 4,
    category: 'Spolupráca',
    question: 'Pracujete aj s malými firmami a živnostníkmi?',
    answer:
      'Absolútne áno. Mnohí naši klienti začínali ako malé firmy s obmedzeným rozpočtom. Máme balíčky šité na mieru aj pre začínajúce podniky. Dôležitejšia ako veľkosť firmy je ochota rásť a investovať do dlhodobého rozvoja.',
  },
  {
    id: 5,
    category: 'Výsledky',
    question: 'Čo ak nebudem spokojný s výsledkami?',
    answer:
      'Pracujeme bez dlhodobých záväzkov - zmluvu je možné ukončiť s mesačnou výpovednou lehotou. Zároveň každé 3 mesiace robíme review, kde spoločne hodnotíme výsledky a upravujeme stratégiu. Váš úspech je priamo náš úspech - to nie je len fráza.',
  },
  {
    id: 6,
    category: 'Proces',
    question: 'Aké podklady a prístupy od nás budete potrebovať?',
    answer:
      'Na začiatku potrebujeme prístupy do Google Analytics, Google Search Console, reklamných účtov a CMS systému webu. Postaráme sa o nastavenie a prepojenie - nemusíte byť technicky zdatní. Celý onboarding zvládneme do 2 pracovných dní.',
  },
  {
    id: 7,
    category: 'Reporting',
    question: 'Ako a ako často dostávam reporty o výsledkoch?',
    answer:
      'Každý mesiac dostanete detailný report s kľúčovými metrikami: návštevnosť, pozície kľúčových slov, výkon kampaní, konverzie a ROI. Okrem toho máte prístup do live dashboardu 24/7. Pri väčších projektoch organizujeme mesačné review hovory.',
  },
  {
    id: 8,
    category: 'Proces',
    question: 'Robíte aj tvorbu webu, alebo len marketing?',
    answer:
      'Robím oboje. Každý projekt riešim osobne od návrhu po spustenie - žiadne delegovanie, žiadne prekvapenia. Dokážem postaviť nový web od nuly, optimalizovať existujúci, alebo prevziať len marketingovú časť. Najlepšie výsledky dosahujeme, keď mám pod kontrolou celý digitálny ekosystém klienta.',
  },
  {
    id: 9,
    category: 'Automatizácie',
    question: 'Čo je n8n a prečo ho používate?',
    answer:
      'n8n je open-source nástroj na automatizáciu pracovných postupov — predstavte si ho ako "digitálneho asistenta", ktorý prepája vaše aplikácie a robí opakujúce sa úlohy za vás. Napríklad: keď príde nový zákazník z webu, automaticky ho pridá do CRM, pošle uvítací email a upozorní vás na Telegrame. Používame ho, pretože je flexibilný, bezpečný a dáta zostávajú u vás.',
  },
  {
    id: 10,
    category: 'Automatizácie',
    question: 'Potrebujem technické znalosti alebo programovanie?',
    answer:
      'Vôbec nie. Celú automatizáciu nastavíme my — vy len popíšete, čo chcete zautomatizovať. Po odovzdaní dostanete jednoduchú dokumentáciu a zaškolenie, aby ste vedeli čo sa deje. Väčšina klientov ovláda výsledok bez akýchkoľvek technických znalostí.',
  },
  {
    id: 11,
    category: 'Automatizácie',
    question: 'Čo je AI agent a na čo mi pomôže?',
    answer:
      'AI agent je inteligentný bot, ktorý dokáže odpovedať na otázky zákazníkov, spracovávať požiadavky alebo vykonávať úlohy — 24/7 bez prestávky. Môže fungovať na vašom webe, v Telegrame alebo WhatsApp. Napríklad: odpovedá na FAQ zákazníkov, kvalifikuje leady alebo automaticky triedi správy podľa priority.',
  },
  {
    id: 12,
    category: 'Automatizácie',
    question: 'Aké aplikácie a systémy viete prepojiť?',
    answer:
      'Prakticky akékoľvek — Google Sheets, Gmail, Slack, Telegram, WhatsApp, CRM systémy (HubSpot, Pipedrive), e-shopy, fakturačné systémy, Meta Ads, Google Ads a stovky ďalších. Ak máte konkrétny systém, radi overíme kompatibilitu pred začatím projektu.',
  },
  {
    id: 13,
    category: 'Automatizácie',
    question: 'Čo sa stane, ak automatizácia prestane fungovať?',
    answer:
      'Každý projekt dodávame s monitoringom a alertmi — ak niečo zlyhá, dostanete okamžité upozornenie. V rámci záruky (30–90 dní podľa balíka) opravíme akýkoľvek problém zadarmo. Po záruke ponúkame mesačnú správu za fixný poplatok.',
  },
  {
    id: 14,
    category: 'Automatizácie',
    question: 'Ako dlho trvá nastavenie automatizácie?',
    answer:
      'Jednoduchá automatizácia (Štart balík) je hotová do 5–7 pracovných dní. Komplexnejšie riešenia s AI agentmi (Biznis/Pro) trvajú 2–4 týždne. Vždy začíname discovery callom, kde presne zmapujeme vaše procesy a navrhneme riešenie ešte pred začatím práce.',
  },
];

export const faqCategories = ['Všetky', 'Spolupráca', 'Ceny', 'Výsledky', 'Proces', 'Reporting', 'Automatizácie'];
